import { Component, OnDestroy, OnInit } from "@angular/core"
import { Observable, Subject, Subscription } from "rxjs"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { ColorCodeService } from "../../services/color-code.service"
import { LearningObject } from "../../models/learningObject.model"
import { FeaturedService } from "../../services/featured.service"
import { UserService } from "../../services/user.service"
import { filter, switchMap, takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-browsing-header",
    templateUrl: "./browsing-header.component.html",
    styleUrls: ["./browsing-header.component.scss"],
    standalone: false,
})
export class BrowsingHeaderComponent implements OnInit, OnDestroy {
    node: CHNode
    backgroundColor = null
    subscriptions: Subscription[] = []
    featuredCollections$: Observable<LearningObject[]>
    showBreadcrumb: boolean

    private destroyed$ = new Subject()
    constructor(
        private browsingService: BrowsingService,
        private colorCodeService: ColorCodeService,
        private featuredService: FeaturedService,
        private userService: UserService
    ) {
        this.backgroundColor = this.colorCodeService.getPrimaryColor()
    }

    public ngOnInit() {
        this.subscribeToFeaturedCollections()
    }

    public subscribeToFeaturedCollections(): void {
        this.featuredCollections$ = this.browsingService.activeNodeChanged.pipe(
            takeUntil(this.destroyed$),
            tap((node: CHNode) => this.setCurrentNode(node)),
            tap((node: CHNode) => this.handleBreadcrumbDisplay(node)),
            filter((node: CHNode) => !!node.id),
            switchMap(() => this.getFeaturedCollections())
        )
    }

    public setCurrentNode(node: CHNode): void {
        const discipline: CHNode = node.getDiscipline()
        const subject: CHNode = node.getSubject()
        this.node = subject || discipline
        this.backgroundColor = this.colorCodeService.getColorForNode(discipline)
    }

    public handleBreadcrumbDisplay(node: CHNode): void {
        this.showBreadcrumb = !!node.getTopParents(1, false).length
    }

    public getFeaturedCollections(): Observable<LearningObject[]> {
        return this.featuredService.getSubjectFeaturedCollections(this.node.id)
    }

    public ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
